/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Copy_Dialogue_SuccessInputs */

const en_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue and metadata copied from Track 2`)
};

const fr_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue et métadonnées copiés depuis la piste 2`)
};

const de_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialoge und Metadaten aus Spur 2 kopiert`)
};

const it_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogo e metadati copiati dalla traccia 2`)
};

const ru_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диалоги и метаданные скопированы со второго трека.`)
};

const es_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo y metadatos copiados de la pista 2`)
};

const zh_cn2_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话和元数据复制自轨道 2`)
};

const ja_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラック2からコピーされた会話とメタデータ`)
};

const hi_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद और मेटाडेटा ट्रैक 2 से कॉपी किए गए हैं`)
};

const pt_pt2_event_group_options_copy_dialogue_success = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo e metadados copiados da Faixa 2.`)
};

/**
* | output |
* | --- |
* | "Dialogue and metadata copied from Track 2" |
*
* @param {Event_Group_Options_Copy_Dialogue_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_copy_dialogue_success = /** @type {((inputs?: Event_Group_Options_Copy_Dialogue_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Copy_Dialogue_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_copy_dialogue_success(inputs)
	if (locale === "de") return de_event_group_options_copy_dialogue_success(inputs)
	if (locale === "it") return it_event_group_options_copy_dialogue_success(inputs)
	if (locale === "ru") return ru_event_group_options_copy_dialogue_success(inputs)
	if (locale === "es") return es_event_group_options_copy_dialogue_success(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_copy_dialogue_success(inputs)
	if (locale === "ja") return ja_event_group_options_copy_dialogue_success(inputs)
	if (locale === "hi") return hi_event_group_options_copy_dialogue_success(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_copy_dialogue_success(inputs)
	return en_event_group_options_copy_dialogue_success(inputs)
});